<script setup lang="ts">
import { LanguageChoice } from '../../i18n'
import { ColumnsInterface, FilteringDisplayOptions } from '../../types/components/data-rendering'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n({ useScope: 'global' })
const localeString = computed(() => locale.value as LanguageChoice)

const props = defineProps<{
  isCollapsed: boolean
  columnLength: number
  sortedColumn: string | null
  sortedValue: boolean
  columns: ColumnsInterface
  checkbox: FilteringDisplayOptions['checks']
  allChecked: boolean
}>()

const emit = defineEmits<{
  (e: 'toggleSort'): void
  (e: 'setSort', key: string): void
  (e: 'toggleAllCheckboxes'): void
}>()

const sortArrow = computed(() => {
  if (props.sortedValue === null) {
    return ''
  } else if (props.sortedValue) {
    return 'las la-sort-down'
  } else {
    return 'las la-sort-up'
  }
})
const toggleSort = () => {
  emit('toggleSort')
}
const setSort = (key: string) => {
  emit('setSort', key)
}
const toggleAllCheckboxes = () => {
  emit('toggleAllCheckboxes')
}
</script>
<template>
  <tr v-if="!isCollapsed" class="table-header text-uppercase tracking-wider text-grey-8">
    <th class="bg-grey-1 sticky-table-columns text-left sticky--left" style="z-index: 4">#</th>
    <th v-if="checkbox?.checklist" class="bg-grey-1 text-bold sticky-table-columns text-left">
      <q-checkbox
        dense
        size="xs"
        :model-value="allChecked"
        @update:model-value="toggleAllCheckboxes()"
        v-bind="checkbox.checkProps"
      />
    </th>
    <template v-for="(column, key) of columns" :key="key">
      <th
        v-if="!column.hide"
        class="bg-grey-1 text-bold sticky-table-columns text-left"
        @click="sortedColumn === key ? toggleSort() : setSort(key)"
        data-test="table-heading"
      >
        {{ column.label[localeString] }}
        <i v-show="sortedColumn === key" :class="sortArrow"></i>
      </th>
    </template>
    <th class="bg-grey-1 text-bold sticky-table-columns text-left" v-if="$slots.itemRight">
      {{ '' }}
    </th>
  </tr>
</template>
